export default {
  LOG_TAG: 'logger',
  d (...params) {
    if (process.env.NODE_ENV !== 'production') {
      console.log(this.LOG_TAG, params)
    }
  },
  isEmpty (str) {
    return !(str && str.trim().length)
  }
}



// WEBPACK FOOTER //
// ./src/utils/logger.js